import CurrencySelect from './CurrencySelect'

export default class Operation {
  constructor(component) {
    this.component = component
    this.selected_operation = null
    this.component.selected_subject = null
    this.component.selected_bank_account = null
    this.component.selected_from_bank_account = null
    this.component.selected_value = 0.0
    this.component.selected_exchanged_value = 0.0
    this.component.reverse_exchange = false
    this.component.selected_payment_method = null
    this.component.selected_from_currency = null
    this.component.selected_to_currency = null
  }
  name() {
    return 'operation'
  }
  handle(event) {
    if(event.cancel) {
      this.component.onClose()
      return
    }
    if(event.selected_operation) {
      this.component.selected_operation = event.selected_operation
      this.component.transaction_controller = new CurrencySelect(this.component)
    }
  }
}



// WEBPACK FOOTER //
// ./src/controllers/NewTransaction/Operation.js